module.exports = __webpack_public_path__ + "static/media/YETI.82a2f658.png";